import { render, staticRenderFns } from "./thinktanPopup.vue?vue&type=template&id=889e5e82&scoped=true"
import script from "./thinktanPopup.vue?vue&type=script&lang=js"
export * from "./thinktanPopup.vue?vue&type=script&lang=js"
import style0 from "./thinktanPopup.vue?vue&type=style&index=0&id=889e5e82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "889e5e82",
  null
  
)

export default component.exports